module.exports = __webpack_public_path__ + "static/media/coindash.ca104f3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screenshots/coindash.png
// module id = 3274
// module chunks = 0